export default __webpack_public_path__ + "static/media/deduction.3770e5f1.mp3";